import { Component, OnInit } from '@angular/core';
import { DropDownModel } from '@app/components/controls/utilities/models/drop-down-model';
import { TextBoxModel } from '@app/components/controls/utilities/models/text-box-model';
import { BaseService } from '@app/system/services/base.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from '../utilities/services/api.service';

@Component({
	selector: 'app-functional-roles-forms',
	templateUrl: './functional-roles-forms.component.html',
	styleUrls: ['./functional-roles-forms.component.scss']
})
export class FunctionalRolesFormsComponent implements OnInit {

	title = '';
	info = '';
	action: 'add' | 'edit' | 'showContent';
	formFields: any = [];
	config = { fxFlex: 100 };
	formObject;
	submitDisable = true;
	popupRef;
	record;

	constructor(
		private apiService: ApiService,
		private gfService: GlobalFunctionService,
		private baseService: BaseService,
		public locale: LocaleService
	) { }

	ngOnInit(): void {
		this.baseService.formView = true;
		if (this.action === 'add') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('new_permission_group');
			const permissionGroup: TextBoxModel = {
				fieldColumn: 'permissionGroup',
				fieldCaption: this.locale.translate('name'),
				additionalMetaData: {
					maxChar: 50
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				value: null,
				fieldPlaceholder: this.locale.translate('name')
			};
			// const parentRole: DropDownModel = {
			// 	fieldColumn: 'parentRole',
			// 	fieldCaption: this.locale.translate('parentRole'),
			// 	fieldType: 'dropDown',
			// 	isHidden: false,
			// 	isMultiple: false,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [],
			// 	additionalMetaData: {
			// 	},
			// 	fieldHelpText: null,
			// 	fieldOrder: 2,
			// 	value: null,
			// 	fieldPlaceholder: this.locale.translate('parentRole')
			// };
			this.formFields = [permissionGroup];
			const apiData = {
				limit: 100
			};
			// const headers: any = {};
			// this.apiService.list(apiData, headers).subscribe(
			// 	(response) => {
			// 		if (response && response.records.length) {
			// 			parentRole.options = response.records.map(data => {
			// 				return {
			// 					key: data.termID,
			// 					value: data.term
			// 				};
			// 			});
			// 		}
			// 	},
			// 	(error) => {
			// 		this.gfService.errorHandler(error, {
			// 			snackBar: {
			// 				position: 'before'
			// 			}
			// 		});
			// 	}
			// )
			// 	.add(() => {
			// 	});
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		} else if (this.action === 'edit') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.locale.translate('edit_permission');
			const permissionGroup: TextBoxModel = {
				fieldColumn: 'permissionGroup',
				fieldCaption: this.locale.translate('name'),
				additionalMetaData: {
					maxChar: 50
				},
				fieldType: 'textBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				type: 'text',
				validationRegex: null,
				value: this.record.term,
				fieldPlaceholder: this.locale.translate('name')
			};
			// const parentRole: DropDownModel = {
			// 	fieldColumn: 'parentRole',
			// 	fieldCaption: this.locale.translate('parentRole'),
			// 	fieldType: 'dropDown',
			// 	isHidden: false,
			// 	isMultiple: false,
			// 	isReadonly: false,
			// 	isRequired: false,
			// 	options: [],
			// 	additionalMetaData: {
			// 	},
			// 	fieldHelpText: null,
			// 	fieldOrder: 2,
			// 	value: this.record.parentRole,
			// 	fieldPlaceholder: this.locale.translate('parentRole')
			// };
			this.formFields = [permissionGroup];
			// const apiData = {
			// 	limit: 100
			// };
			// const headers: any = {};
			// this.apiService.list(apiData, headers).subscribe(
			// 	(response) => {
			// 		if (response && response.records.length) {
			// 			for (const data of response.records) {
			// 				if (data.termID !== this.record.termID) {
			// 					parentRole.options.push(
			// 						{
			// 							key: data.termID,
			// 							value: data.term
			// 						}
			// 					);
			// 				}
			// 			}
			// 		}
			// 	},
			// 	(error) => {
			// 		this.gfService.errorHandler(error, {
			// 			snackBar: {
			// 				position: 'before'
			// 			}
			// 		});
			// 	}
			// )
			// 	.add(() => {
			// 	});
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		} else if (this.action === 'showContent') {
			this.popupRef.componentInstance.popupLoader = true;
			this.title = this.record.term;
			this.popupRef.componentInstance.popupLoader = false;
			this.submitDisable = false;
		}
	}

	formObjectReader(record) {
		this.formObject = record;
	}

	update() {
		if (navigator.onLine) {
			if (this.action === 'add') {
				this.add();
			} else if (this.action === 'edit') {
				this.edit();
			}
		}
	}

	add() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('functionalRole');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const headers: any = {};
				this.apiService
					.add(formValue, headers)
					.subscribe(
						(response) => {
							if (response) {
								this.popupRef.close(this.gfService.JSONMerge(formValue, response));
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('permission_group_created'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
								error.error = this.locale.translate('this_item_being_added');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'functionalRole'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}

	edit() {
		if (this.formObject && this.formObject.form) {
			this.gfService.alertClear('functionalRole');
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				this.popupRef.componentInstance.popupLoader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				// if (formValue.parentRole === '') {
				// 	formValue.parentRole = null;
				// }
				const headers: any = {};
				this.apiService
					.update(formValue, this.record.termID, headers)
					.subscribe(
						(response) => {
							if (response) {
								this.popupRef.close(formValue);
								this.gfService.openSnackBar('SUCCESS', {
									message: this.locale.translate('permission_group_updated'),
									icon: 'check_circle_outline',
									position: 'before'
								});
							}
						},
						(error) => {
							if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
								error.error = this.locale.translate('this_item_being_added');
							}
							this.gfService.errorHandler(error, {
								alert: {
									id: 'functionalRole'
								},
								form: this.formObject.form
							});
						}
					)
					.add(() => {
						this.submitDisable = false;
						this.popupRef.componentInstance.popupLoader = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
				this.submitDisable = false;
			}
		}
	}
}
